




































































import { Component, Vue } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import { Registration as IRegistration } from "@/api-v2/course/models/registration";
import { LearningProgress as ILearningProgress } from "@/api-v2/course/models/learning-progress";
import { LearningUnitProgress as ILearningUnitProgress } from "@/api-v2/course/models/learning-unit-progress";
import { courseApi } from "@/getinfo-api";
import TextField from "@/components/form/CustomPage/textField.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import LearningUnitProgressTableItem from "@/components/learning-progress/LearningUnitProgressTableItem.vue";
import { progressStatusV2 } from "@/plugins/learning-status";

@Component({
  components: {
    LearningUnitProgressTableItem,
    CustomTable,
    TextField,
    CBlock,
    CPage
  }
})
export default class CourseRegistrationProgressView extends Vue {
  registration!: IRegistration;
  progress!: ILearningProgress;

  data() {
    return {
      registration: undefined,
      progress: undefined
    };
  }

  get status() {
    return progressStatusV2(this.registration?.status);
  }

  get studentName() {
    return `${
      this.registration?.student?.lastName
        ? this.registration?.student?.lastName
        : ""
    }
    ${
      this.registration?.student?.firstName
        ? this.registration?.student?.firstName
        : ""
    }
    ${
      this.registration?.student?.middleName
        ? this.registration?.student?.middleName
        : ""
    }`;
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "learningProgress" },
        label: `${this.$tc(this.$translate.LearnerProgress)}`
      },
      {
        label: this.$converter.limitedOutput(
          this.registration?.course?.title,
          40
        )
      }
    ];
  }

  getSessions(units: ILearningUnitProgress[], id: string) {
    let newArray = Object.entries(units);
    const myMap = new Map(newArray);
    return myMap?.get(id)?.sessions;
  }

  get units() {
    return this.registration?.course?.learningUnits?.map(el => {
      return {
        detailUnitInfo: el,
        sessions: this.getSessions(this.progress?.learningUnits, el.id),
        parentId: el.parentId ? el.parentId : null,
        deepLevel: this.getDeepLevel(el.parentId)
      };
    });
  }

  getDeepLevel(parentId: string | undefined, level: number = 0): number {
    let _level: number = level;
    if (parentId) {
      const parent = this.registration?.course?.learningUnits?.find(
        unit => parentId === unit?.id
      );
      if (parent) {
        _level += 1;
        this.getDeepLevel(parent?.parentId, _level);
      } else {
        return _level;
      }
    }
    return _level;
  }

  async getRegistration() {
    const { data } = await courseApi.CourseRegistration.getCourseRegistration(
      this.$route.params.id
    );
    this.registration = data;
  }

  async getLearningProgressByRegistrationId() {
    const { data } = await courseApi.LearningProgress.getLearningProgress(
      this.$route.params.id,
      ["sessions"]
    );
    this.progress = data;
  }

  created() {
    this.getRegistration();
    this.getLearningProgressByRegistrationId();
  }
}
